module.exports = __webpack_public_path__ + "img/lottba3.1a510afb.png";